<template>
  <section id="dashboard-business">
    <b-row class="match-height">
      <!-- General Statistics -->
      <b-col
        xl="12"
        md="12"
      >
        <general-statistics-widget />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <!-- Project Statistics -->
      <b-col
        lg="8"
        md="12"
      >
        <project-statistics-widget />
      </b-col>

      <!-- Employee Statistics -->
      <b-col
        lg="4"
        md="12"
      >
        <employee-statistics-widget />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <!-- Financial Summary -->
      <b-col
        lg="8"
        md="12"
      >
        <financial-summary-widget />
      </b-col>

      <!-- Customer Statistics -->
      <b-col
        lg="4"
        md="12"
      >
        <customer-statistics-widget />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <!-- Task Summary -->
      <b-col
        lg="8"
        md="12"
      >
        <task-summary-widget />
      </b-col>

      <!-- Recent Activities -->
      <b-col
        lg="4"
        md="12"
      >
        <recent-activities-widget />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import GeneralStatisticsWidget from './widgets/GeneralStatisticsWidget.vue'
import ProjectStatisticsWidget from './widgets/ProjectStatisticsWidget.vue'
import FinancialSummaryWidget from './widgets/FinancialSummaryWidget.vue'
import TaskSummaryWidget from './widgets/TaskSummaryWidget.vue'
import EmployeeStatisticsWidget from './widgets/EmployeeStatisticsWidget.vue'
import CustomerStatisticsWidget from './widgets/CustomerStatisticsWidget.vue'
import RecentActivitiesWidget from './widgets/RecentActivitiesWidget.vue'

export default {
  name: 'BusinessDashboard',
  components: {
    BRow,
    BCol,
    GeneralStatisticsWidget,
    ProjectStatisticsWidget,
    FinancialSummaryWidget,
    TaskSummaryWidget,
    EmployeeStatisticsWidget,
    CustomerStatisticsWidget,
    RecentActivitiesWidget,
  },
  computed: {
    ...mapGetters('dashboard', ['overview', 'loading']),
  },
  methods: {
    ...mapActions('dashboard', ['fetchOverview']),
  },
  created() {
    // Fetch all dashboard data on mount
    this.fetchOverview().catch(error => {
      console.error('Error fetching dashboard overview:', error)
    })
  },
}
</script>

<style lang="scss" scoped>
#dashboard-business {
  .match-height > [class*='col'] {
    display: flex;
    flex-flow: column;
  }
}
</style>
